function getNiceDate(date, seperator = '/', invertDayMonth = false) {
    if (date && date.getDate) {
        if (invertDayMonth === false) {
            return zero(date.getDate().toString()) + seperator + zero((date.getMonth() + 1).toString()) + seperator + date.getFullYear();
        }
        else {
            return zero((date.getMonth() + 1).toString()) + seperator + zero(date.getDate().toString()) + seperator + date.getFullYear();
        }
    }
    return '';
}
function randomDate(start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
}
function stringToNiceDateTime(dateTime) {
    if (dateTime) {
        const d = new Date(dateTime);
        // tslint:disable-next-line: max-line-length
        let timeInfo = ' ' + zero(d.getHours().toString()) + ':' + zero(d.getMinutes().toString());
        if (timeInfo.includes('00:00')) {
            timeInfo = '';
        }
        return zero(d.getDate().toString()) + '/' + zero((d.getMonth() + 1).toString()) + '/' + d.getFullYear() + timeInfo;
    }
    return '';
}
function stringToNiceDate(date) {
    if (date) {
        const d = new Date(date);
        // tslint:disable-next-line: max-line-length
        return zero(d.getDate().toString()) + '/' + zero((d.getMonth() + 1).toString()) + '/' + d.getFullYear();
    }
    return '';
}
function zero(datePart) {
    if (datePart.length === 1) {
        datePart = '0' + datePart;
    }
    return datePart;
}
function getNiceDateTime(dateTime) {
    if (dateTime) {
        return stringToNiceDateTime(dateTime.toString());
    }
    return '';
}
function isStringADateFormat(value) {
    if (!value || typeof value != 'string') {
        return false;
    }
    let dashOccurences = (value.split("-").length - 1);
    let doubleOccurences = (value.split(":").length - 1);
    if (Date.parse(value) &&
        (dashOccurences === 2 || dashOccurences === 3) &&
        (doubleOccurences === 2 || doubleOccurences === 3)) {
        return true;
    }
    return false;
}

function getNiceBool(yesNo) {
    if (yesNo === false) {
        return 'No';
    }
    else if (yesNo === true) {
        return 'Yes';
    }
    else if (yesNo === 'true') {
        return 'Yes';
    }
    else if (yesNo === 'false') {
        return 'No';
    }
    else {
        return yesNo;
    }
}

function hasValidValue(property) {
    if (property === undefined || property === null) {
        return false;
    }
    else {
        return true;
    }
}
function getNestedProperty(object, propertyChain) {
    let exists = true;
    if (!hasValidValue(object)) {
        return null;
    }
    propertyChain.forEach((p) => {
        if (object[p] === undefined || object[p] === null) {
            exists = false;
        }
        else {
            object = object[p];
        }
    });
    if (exists === true) {
        return object;
    }
    else {
        return null;
    }
}
function sleep(milliseconds) {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
}
function getRandomNumber(max, min = 0) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
function endOfForEach(array, index) {
    if (Object.is(array.length - 1, index)) {
        return true;
    }
    return false;
}
function moveElementInArrayUp(indexThatShouldGoUp, target) {
    if (indexThatShouldGoUp <= 0) {
        return;
    }
    const cachedProperty = target[indexThatShouldGoUp];
    target.splice(indexThatShouldGoUp, 1);
    target.splice(indexThatShouldGoUp - 1, 0, cachedProperty);
}
function moveElementInArrayDown(indexThatShouldGoDown, target) {
    if (indexThatShouldGoDown >= target.length - 1) {
        return;
    }
    const cachedProperty = target[indexThatShouldGoDown];
    target.splice(indexThatShouldGoDown, 1);
    target.splice(indexThatShouldGoDown + 1, 0, cachedProperty);
}
function getNestedPropertyAsString(object, propertyChain) {
    const property = getNestedProperty(object, propertyChain);
    if (hasValidValue(property)) {
        return property;
    }
    else {
        return '';
    }
}
function removeEmptyStringsAndEmptyPropertiesFromObject(object) {
    if (object) {
        for (const name of Object.keys(object)) {
            if (object[name] === '' || !hasValidValue(object[name])) {
                delete object[name];
            }
        }
    }
}
function clonePOJO(object) {
    if (object) {
        return JSON.parse(JSON.stringify(object));
    }
    else {
        return object;
    }
}
function makeId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
function makeLicId(length) {
    let result = '';
    const characters = 'ABCDEF0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
function pojoToArray(pojoObject) {
    const array = [];
    for (const prop in pojoObject) {
        if (Object.prototype.hasOwnProperty.call(pojoObject, prop)) {
            array.push(pojoObject[prop]);
        }
    }
    return array;
}
function objectAsIterableArray(pojoObject) {
    if (!pojoObject) {
        return [];
    }
    const array = [];
    let cnt = 0;
    for (const prop in pojoObject) {
        if (Object.prototype.hasOwnProperty.call(pojoObject, prop)) {
            let obj = {};
            obj.dicKey = prop;
            obj.dicValue = pojoObject[prop];
            array.push(obj);
        }
        cnt++;
    }
    return array;
}
function removeEmptyStringsAndNullValuesFromObjectAndReturnCopy(obj) {
    const newObj = {};
    if (!obj) {
        return null;
    }
    for (const prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            if (hasValidValue(obj[prop]) && obj[prop] !== '') {
                newObj[prop] = obj[prop];
            }
        }
    }
    return newObj;
}
function safeProperty(name) {
    return name;
}
function hasProperties(obj) {
    let hasProperties = false;
    if (!obj) {
        return hasProperties;
    }
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            hasProperties = true;
        }
    }
    return hasProperties;
}
function compareTwoArrays(arrayOne, arrayTwo) {
    if (!arrayOne)
        return false;
    // compare lengths - can save a lot of time 
    if (arrayTwo.length != arrayOne.length)
        return false;
    for (var i = 0, l = arrayTwo.length; i < l; i++) {
        // Check if we have nested arrays
        if (arrayTwo[i] instanceof Array && arrayOne[i] instanceof Array) {
            // recurse into the nested arrays
            if (!arrayTwo[i].equals(arrayOne[i]))
                return false;
        }
        else if (arrayTwo[i] != arrayOne[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
}
function arrayToString(array) {
    let str = '';
    for (let a of array) {
        str += a + ', ';
    }
    return str;
}
function beautifyUndef(v) {
    if (v) {
        return v + '';
    }
    else {
        return '';
    }
}
function getEntityFromDatabucket(dataBucket, type) {
    let entity = new type();
    // entity = {...dataBucket, ...entity};
    entity = Object.assign(entity, dataBucket);
    return entity;
}
function getEntitiesFromDatabuckets(dataBuckets, type) {
    let entities = [];
    for (let bucket of dataBuckets) {
        let entity = getEntityFromDatabucket(bucket, type);
        entities.push(entity);
    }
    return entities;
}

class MenuItem {
    constructor(Title, Url, Fragment = null) {
        this.Title = Title;
        this.Url = Url;
        this.Fragment = Fragment;
        this.IsExternal = false;
        this.Activated = false;
        this.IconCssClass = '';
    }
}

/*
 * Public API Surface of datahive-basic
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MenuItem, arrayToString, beautifyUndef, clonePOJO, compareTwoArrays, endOfForEach, getEntitiesFromDatabuckets, getEntityFromDatabucket, getNestedProperty, getNestedPropertyAsString, getNiceBool, getNiceDate, getNiceDateTime, getRandomNumber, hasProperties, hasValidValue, isStringADateFormat, makeId, makeLicId, moveElementInArrayDown, moveElementInArrayUp, objectAsIterableArray, pojoToArray, randomDate, removeEmptyStringsAndEmptyPropertiesFromObject, removeEmptyStringsAndNullValuesFromObjectAndReturnCopy, safeProperty, sleep, stringToNiceDate, stringToNiceDateTime };
